(function () {
  function money(cents, format) {
    if (typeof cents !== 'number' || Number.isNaN(cents)) return '';
    var value = (cents / 100).toFixed(2);
    if (!format) return value;
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  function selectedPack(root) {
    var checked = root.querySelector('input[name="quantity"]:checked');
    if (!checked) checked = root.querySelector('input[name="quantity"]');
    if (!checked) {
      return { qty: 1, price: 0, subscribePrice: 0, compare: 0, label: '', save: 0, subscribeSave: 0, servings: 1, percent: 0 };
    }
    return {
      qty: parseInt(checked.value, 10) || 1,
      price: parseInt(checked.getAttribute('data-bundle-price'), 10) || 0,
      subscribePrice: parseInt(checked.getAttribute('data-bundle-subscribe-price'), 10) || parseInt(checked.getAttribute('data-bundle-price'), 10) || 0,
      compare: parseInt(checked.getAttribute('data-bundle-compare'), 10) || 0,
      label: checked.getAttribute('data-bundle-label') || '',
      save: parseInt(checked.getAttribute('data-bundle-save'), 10) || 0,
      subscribeSave: parseInt(checked.getAttribute('data-bundle-subscribe-save'), 10) || 0,
      servings: parseInt(checked.getAttribute('data-bundle-servings'), 10) || 1,
      percent: parseInt(checked.getAttribute('data-save-percent'), 10) || 0,
    };
  }

  function planInput(box) {
    var formId = box.getAttribute('data-form');
    var form = formId ? document.getElementById(formId) : null;
    var hidden = form && form.querySelector('[data-lumessy-selling-plan]');
    if (hidden) return hidden;
    hidden = box.querySelector('[data-lumessy-selling-plan]');
    if (form && hidden && hidden.parentElement !== form) {
      form.appendChild(hidden);
    }
    return hidden;
  }

  function addonTotal(root) {
    var total = 0;
    var names = [];
    root.querySelectorAll('product-info-upsell.lumessy-bundle-addon[data-selected="true"]').forEach(function (addon) {
      if (addon.getAttribute('data-available') === 'false') return;
      total += parseInt(addon.getAttribute('data-price'), 10) || 0;
      var title = addon.querySelector('.upsell__title h3');
      if (title && title.textContent) names.push(title.textContent.trim());
    });
    return { total: total, names: names };
  }

  function purchaseType(root) {
    var box = root.querySelector('[data-lumessy-plans]');
    if (!box) return 'onetime';
    var typeInput = box.querySelector('input[name^="lumessy-purchase-"]:checked');
    return typeInput ? typeInput.value : 'onetime';
  }

  function currentTotals(root) {
    var pack = selectedPack(root);
    var extras = addonTotal(root);
    var type = purchaseType(root);
    var price = type === 'subscribe' ? pack.subscribePrice : pack.price;
    var compare = Math.max(pack.compare, pack.price);
    return {
      price: price + extras.total,
      compare: compare + extras.total,
      pack: pack,
      extras: extras,
      type: type,
    };
  }

  function updateCardPrices(root) {
    var format = root.getAttribute('data-money-format') || '';
    var type = purchaseType(root);
    var servingLabel = root.getAttribute('data-serving-label') || '/ serving';
    root.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      var label = root.querySelector('label[for="' + input.id + '"]');
      if (!label) return;
      var onetime = parseInt(input.getAttribute('data-bundle-price'), 10) || 0;
      var subscribe = parseInt(input.getAttribute('data-bundle-subscribe-price'), 10) || onetime;
      var compare = parseInt(input.getAttribute('data-bundle-compare'), 10) || 0;
      var servings = parseInt(input.getAttribute('data-bundle-servings'), 10) || 1;
      var live = type === 'subscribe' ? subscribe : onetime;
      var priceEl = label.querySelector('[data-plan-price]');
      var compareEl = label.querySelector('[data-plan-compare]');
      var servingEl = label.querySelector('[data-plan-serving]');
      if (priceEl) priceEl.textContent = money(live, format);
      if (compareEl) {
        if (compare > live) {
          compareEl.textContent = money(compare, format);
          compareEl.classList.remove('hidden');
        } else {
          compareEl.textContent = '';
          compareEl.classList.add('hidden');
        }
      }
      if (servingEl && servings > 0) {
        servingEl.textContent = money(Math.round(live / servings), format) + ' ' + servingLabel;
      }
    });
  }

  function updateSticky(root, totals) {
    var sectionId = root.getAttribute('data-section');
    if (!sectionId) return;
    var format = root.getAttribute('data-money-format') || '';
    var atcPrice = document.getElementById('main-atc-price-' + sectionId);
    if (atcPrice) atcPrice.textContent = money(totals.price, format) + ' •';
    var stickyPrice = document.getElementById('sticky-atc-price-' + sectionId);
    if (stickyPrice) stickyPrice.textContent = money(totals.price, format) + ' •';
    var stickyPlan = document.getElementById('sticky-atc-plan-' + sectionId);
    if (stickyPlan) {
      var parts = [];
      if (totals.pack.label) parts.push(totals.pack.label);
      if (totals.type === 'subscribe') parts.push('Subscribe');
      stickyPlan.textContent = parts.join(' · ');
      stickyPlan.hidden = parts.length === 0;
    }
  }

  function updateSummary(root) {
    var summary = root.querySelector('[data-lumessy-summary]');
    var format = root.getAttribute('data-money-format') || '';
    var totals = currentTotals(root);
    var labelParts = [];
    if (totals.pack.label) labelParts.push(totals.pack.label);
    if (totals.type === 'subscribe') labelParts.push('Subscribe');
    if (totals.extras.names.length) labelParts = labelParts.concat(totals.extras.names);
    if (summary) {
      var name = summary.querySelector('[data-summary-label]');
      var price = summary.querySelector('[data-summary-price]');
      var save = summary.querySelector('[data-summary-save]');
      if (name) name.textContent = labelParts.join(' + ') || 'Your pack';
      if (price) price.textContent = money(totals.price, format);
      if (save) {
        var saved = totals.compare > totals.price ? totals.compare - totals.price : 0;
        if (saved > 0) {
          save.hidden = false;
          save.textContent = 'You save ' + money(saved, format);
        } else {
          save.hidden = true;
          save.textContent = '';
        }
      }
    }
    updateSticky(root, totals);
  }

  function updatePlanPrices(root, box) {
    var pack = selectedPack(root);
    var format = box.getAttribute('data-money-format') || '';
    var onetimePrice = box.querySelector('[data-onetime-price]');
    var onetimeCompare = box.querySelector('[data-onetime-compare]');
    if (onetimePrice) onetimePrice.textContent = money(pack.price, format);
    if (onetimeCompare) {
      onetimeCompare.textContent = pack.compare > pack.price ? money(pack.compare, format) : '';
    }
    updateCardPrices(root);
    updateSummary(root);
  }

  function syncSellingPlan(root) {
    var box = root.querySelector('[data-lumessy-plans]');
    var type = purchaseType(root);
    root.classList.toggle('lumessy-bundle--purchase-subscribe', type === 'subscribe');
    root.classList.toggle('lumessy-bundle--purchase-onetime', type === 'onetime');
    if (!box) {
      updateCardPrices(root);
      updateSummary(root);
      return;
    }
    var hidden = planInput(box);
    var select = box.querySelector('[data-lumessy-plan-select]');
    box.querySelectorAll('.lumessy-bundle-plans__option').forEach(function (option) {
      option.classList.toggle('is-selected', option.getAttribute('data-plan-type') === type);
    });
    if (hidden) {
      if (type === 'subscribe' && select && select.value) {
        hidden.setAttribute('name', 'selling_plan');
        hidden.value = select.value;
        hidden.disabled = false;
      } else {
        hidden.value = '';
        hidden.disabled = true;
      }
    }
    updatePlanPrices(root, box);
  }

  function refreshAddon(addon) {
    var selected = addon.getAttribute('data-selected') === 'true';
    var plus = addon.querySelector('.lumessy-bundle-addon__plus');
    var state = addon.querySelector('[data-addon-state]');
    if (plus) plus.setAttribute('aria-pressed', selected ? 'true' : 'false');
    if (state) state.textContent = selected ? 'Added' : 'Add';
  }

  function bind(root) {
    if (!root || root.dataset.lumessyBound === 'true') return;
    root.dataset.lumessyBound = 'true';

    root.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      input.addEventListener('change', function () {
        var box = root.querySelector('[data-lumessy-plans]');
        if (box) {
          var subscribe = box.querySelector('[data-subscribe-radio], input[value="subscribe"]');
          if (subscribe) subscribe.checked = true;
        }
        syncSellingPlan(root);
      });
    });

    var box = root.querySelector('[data-lumessy-plans]');
    if (box) {
      box.querySelectorAll('input[name^="lumessy-purchase-"]').forEach(function (input) {
        input.addEventListener('change', function () {
          syncSellingPlan(root);
        });
      });
      var select = box.querySelector('[data-lumessy-plan-select]');
      if (select) {
        select.addEventListener('change', function () {
          var subscribe = box.querySelector('[data-subscribe-radio], input[value="subscribe"]');
          if (subscribe) subscribe.checked = true;
          syncSellingPlan(root);
        });
        select.addEventListener('click', function (event) {
          event.stopPropagation();
        });
      }
      if (box.getAttribute('data-default') === 'subscribe') {
        var subscribe = box.querySelector('[data-subscribe-radio], input[value="subscribe"]');
        if (subscribe) subscribe.checked = true;
      }
    }

    root.querySelectorAll('product-info-upsell.lumessy-bundle-addon').forEach(function (addon) {
      refreshAddon(addon);
      addon.addEventListener('click', function () {
        window.setTimeout(function () {
          refreshAddon(addon);
          updateSummary(root);
        }, 0);
      });
      if (window.MutationObserver) {
        new MutationObserver(function () {
          refreshAddon(addon);
          updateSummary(root);
        }).observe(addon, { attributes: true, attributeFilter: ['data-selected'] });
      }
    });

    syncSellingPlan(root);
    updateSummary(root);
  }

  function bindFactsLink() {
    document.querySelectorAll('[data-pdp-facts-link]').forEach(function (link) {
      if (link.dataset.bound === 'true') return;
      link.dataset.bound = 'true';
      link.addEventListener('click', function (event) {
        var target = document.getElementById('pdp-supplement-facts');
        if (!target) {
          document.querySelectorAll('.product__accordion .accordion__title').forEach(function (title) {
            if (title.textContent && title.textContent.toLowerCase().indexOf('ingredient') !== -1) {
              target = title.closest('.product__accordion');
            }
          });
        }
        if (!target) return;
        event.preventDefault();
        var details = target.querySelector('details');
        if (details && !details.open) details.open = true;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function init() {
    document.querySelectorAll('quantity-breaks.lumessy-bundle').forEach(bind);
    bindFactsLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
